import { motion } from 'framer-motion';
import { Phone, MapPin, Mail, ArrowUpRight } from 'lucide-react';
import { companyInfo, whatsappNumber } from '../data/siteData';
import { luxuryEase, viewportOnce } from '../lib/motion';

const rows = [
  {
    Icon: Phone,
    label: 'Telefon',
    value: companyInfo.phone,
    href: `tel:${companyInfo.phone.replace(/\s/g, '')}`,
  },
  {
    Icon: Mail,
    label: 'E-posta',
    value: companyInfo.email,
    href: `mailto:${companyInfo.email}`,
  },
  {
    Icon: MapPin,
    label: 'Ofis',
    value: companyInfo.address,
    href: `https://maps.google.com/?q=${encodeURIComponent(companyInfo.address)}`,
  },
];

export default function Contact() {
  return (
    <section id="contact" className="bg-nosta-ink text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid lg:grid-cols-12 gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportOnce}
            transition={{ duration: 0.9, ease: luxuryEase }}
            className="lg:col-span-5"
          >
            <p className="eyebrow mb-4">İletişim</p>
            <h2 className="font-display text-4xl md:text-6xl leading-tight">
              Villayı yerinde görün.
            </h2>
            <p className="mt-6 text-white/55 leading-relaxed max-w-md">
              Enez satışı, planlar ve yatırım koşulları için doğrudan teknik ofisle konuşun. WhatsApp veya telefon, aynı gün dönüş.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="gold-btn"
              >
                WhatsApp’tan yazın
              </a>
              <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="ghost-btn">
                Hemen ara
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportOnce}
            transition={{ duration: 0.9, ease: luxuryEase }}
            className="lg:col-span-7 border-t lg:border-t-0 lg:border-l border-white/10 pt-10 lg:pt-0 lg:pl-16 space-y-0"
          >
            {rows.map(({ Icon, label, value, href }, i) => (
              <a
                key={label}
                href={href}
                target={href.startsWith('http') ? '_blank' : undefined}
                rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
                className={`group flex gap-5 py-8 ${i < rows.length - 1 ? 'border-b border-white/10' : ''} hover:translate-x-1 transition-transform`}
              >
                <Icon className="w-5 h-5 text-nosta-gold mt-1 shrink-0" />
                <div className="flex-1">
                  <div className="eyebrow mb-2">{label}</div>
                  <div className="text-lg leading-relaxed text-white/85 group-hover:text-white">{value}</div>
                </div>
                <ArrowUpRight className="w-4 h-4 text-white/30 group-hover:text-nosta-gold mt-1 shrink-0" />
              </a>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
